import { ServiceOrderService } from 'src/app/services/apps/service-order/service-order.service';
import { ParamMap } from '@angular/router';
import {
  carriedNavigationContext,
  readNavigationContext,
} from 'src/app/services/navigation/navigation-context.service';
import {
  PageAbove,
  PageInfo,
} from 'src/assets/types/interface/page-info.interface';
import { buildServiceOrderPageInfo } from './service-order-page-info.builder';

export async function buildServiceOrderChecklistPageInfo(
  route: string,
  serviceOrderUuid: string,
  checklistUuid: string | null,
  sourceRevision: string | null,
  queryParams: ParamMap,
  tenantType: string,
  serviceOrderService: ServiceOrderService,
): Promise<PageInfo> {
  const serviceOrderPage = await buildServiceOrderPageInfo(
    serviceOrderUuid,
    tenantType,
    serviceOrderService,
    readNavigationContext(queryParams),
  );
  const pagesAbove: PageAbove[] = [
    ...serviceOrderPage.pagesAbove,
    {
      title: serviceOrderPage.title || 'Ordem de Serviço: ',
      identification: serviceOrderPage.identification ?? '',
      url: '/gestao/ordem-servico/detalhes/:serviceOrderUuid',
      queryParams: carriedNavigationContext(queryParams),
      description: 'Detalhes da ordem de serviço',
    },
  ];

  if (route.includes('/plano/')) {
    pagesAbove.push(
      checklistsPage(serviceOrderUuid, checklistUuid, queryParams),
    );
    return {
      identification: sourceRevision ? ` · revisão ${sourceRevision}` : '',
      title: 'Plano de referência',
      pagesAbove,
    };
  }

  if (checklistUuid) {
    pagesAbove.push(
      checklistsPage(serviceOrderUuid, checklistUuid, queryParams),
    );
    return {
      identification: '',
      title: 'Checklist',
      pagesAbove,
    };
  }

  return {
    identification: '',
    title: 'Todos os checklists',
    pagesAbove,
  };
}

function checklistsPage(
  serviceOrderUuid: string,
  checklistUuid: string | null,
  params: ParamMap,
): PageAbove {
  const queryParams: Record<string, string> = {
    ...carriedNavigationContext(params),
  };
  for (const key of ['q', 'status', 'page', 'workspaceReturnTo']) {
    const value = params.get(key);
    if (value) queryParams[key] = value;
  }
  if (checklistUuid) queryParams['checklist'] = checklistUuid;

  return {
    title: 'Todos os checklists',
    url: `/gestao/ordens-servico/${serviceOrderUuid}/checklists`,
    queryParams: Object.keys(queryParams).length ? queryParams : undefined,
    description: 'Checklists da ordem de serviço',
  };
}
